export var defaultValidation = function defaultValidation(schema, formData, errors) {
  validateMask(schema, formData, errors);
  validateDecimals(schema, formData, errors);
  return errors;
};

export var transformErrors = function transformErrors(errors) {
  return errors.map(function (error) {
    if (error.name === "required") {
      error.message = "campo obrigatório";
    }
    return error;
  });
};

var isCnpjValid = function isCnpjValid(strCnpj) {
  var b = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

  if ((strCnpj = strCnpj.replace(/[^\d]/g, "")).length != 14) return false;

  if (/0{14}/.test(strCnpj)) return false;

  for (var i = 0, n = 0; i < 12; n += strCnpj[i] * b[++i]) {}
  if (strCnpj[12] != ((n %= 11) < 2 ? 0 : 11 - n)) return false;

  for (var i = 0, n = 0; i <= 12; n += strCnpj[i] * b[i++]) {}
  if (strCnpj[13] != ((n %= 11) < 2 ? 0 : 11 - n)) return false;

  return true;
};

var isCpfValid = function isCpfValid(strCPF) {
  var invalidCpfs = ["00000000000", "11111111111", "22222222222", "33333333333", "44444444444", "55555555555", "66666666666", "77777777777", "88888888888", "99999999999"];

  var sum = void 0;
  var rest = void 0;
  sum = 0;
  if (invalidCpfs.includes(strCPF)) return false;

  for (var i = 1; i <= 9; i++) {
    sum = sum + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
  }rest = sum * 10 % 11;

  if (rest == 10 || rest == 11) rest = 0;
  if (rest != parseInt(strCPF.substring(9, 10))) return false;

  sum = 0;
  for (var _i = 1; _i <= 10; _i++) {
    sum = sum + parseInt(strCPF.substring(_i - 1, _i)) * (12 - _i);
  }rest = sum * 10 % 11;

  if (rest == 10 || rest == 11) rest = 0;
  if (rest != parseInt(strCPF.substring(10, 11))) return false;
  return true;
};

var validateDecimals = function validateDecimals(schema, formData, errors) {
  var inputsDecimals = findFieldsByType(schema, ["input-decimal"]);

  if (!inputsDecimals.length) {
    return;
  }

  inputsDecimals.map(function (field) {
    var key = field.metadata.key;

    var value = formData[key];

    if (!value) {
      return;
    }

    var NUMBER_REGEX = /^\d+$/;
    var DECIMAL_REGEX = /^\d+\.\d{0,99}$/;

    if (NUMBER_REGEX.test(value)) {
      return;
    }

    if (!DECIMAL_REGEX.test(value)) {
      errors[key].addError("Valor inválido");
    }
  });
};

var validateMask = function validateMask(schema, formData, errors) {
  var inputsMask = findFieldsByType(schema, ["mask", "input-cpf", "input-cnpj"]);

  if (!inputsMask.length) {
    return;
  }

  inputsMask.map(function (field) {
    var _field$metadata = field.metadata,
        key = _field$metadata.key,
        type = _field$metadata.type;

    var value = formData[key];

    if (value === undefined) {
      return;
    }

    if (value.indexOf("_") > -1) {
      errors[key].addError("valor inválido");
    }

    if (type === "input-cpf" && !isCpfValid(value.split(".").join("").split("-").join(""))) {
      errors[key].addError("cpf inválido");
    }

    if (type === "input-cnpj" && !isCnpjValid(value.split(".").join("").split("-").join("").split("/").join(""))) {
      errors[key].addError("cnpj inválido");
    }
  });
};

var findFieldsByType = function findFieldsByType(schema, typesToFind) {
  var fields = [];

  Object.keys(schema.properties).map(function (property) {
    var field = schema.properties[property];
    if (typesToFind.includes(field.metadata.type)) {
      fields.push(field);
    }
  });

  return fields;
};